import {
  createFrontendModule,
  PageLayout,
} from '@backstage/frontend-plugin-api';
import { SwappableComponentBlueprint } from '@backstage/plugin-app-react';

export const pageLayoutModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SwappableComponentBlueprint.make({
      name: 'kpc-page-layout',
      params: define =>
        define({
          component: PageLayout,
          loader: () =>
            import('./page-layout').then(m => m.KpcPageLayout),
        }),
    }),
  ],
});
